import { DurationRange } from '../Provider';
import { getItineraryDuration } from 'clientState/providers/ParsedSearchResponseProvider';

const predicate =
  (range: DurationRange) =>
  (itinerary): boolean => {
    if (!range) return true;
    const itineraryDuration = getItineraryDuration(itinerary.legs);
    return (
      itineraryDuration >= range.minDays && itineraryDuration <= range.maxDays
    );
  };

export default predicate;
